import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

const settings = { timestampsInSnapshots: true };

const config = {
    apiKey: "AIzaSyCFJzOEnJZ_5DcaCEM_gtd0EdOhpjYcKBA",
    authDomain: "smartgrowthdiary.firebaseapp.com",
    databaseURL: "https://smartgrowthdiary.firebaseio.com",
    projectId: "smartgrowthdiary",
    storageBucket: "smartgrowthdiary.firebasestorage.app",
    messagingSenderId: "794136119428",
    appId: "1:794136119428:web:c2779677afa2cd3c90dad1",
    measurementId: "G-8CRG39GJ5F"
};

firebase.initializeApp(config);

const firestore = firebase.firestore();
firestore.settings(settings);

// Enable Firestore persistence to make all documents received available offline
firestore.enablePersistence().catch((err) => {
    if (err.code === 'failed-precondition') {
        console.log('Multiple tabs open, persistence can only be enabled in one tab at a time.');
    } else if (err.code === 'unimplemented') {
        console.log('The current browser does not support all of the features required to enable persistence.');
    }
});

export const storage = firebase.storage();
export default firebase;
